import React from "react";
export default class FeedbackContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      feedback: ""
    };
    this._updateFeedback = this._updateFeedback.bind(this);
  }

  _updateFeedback(e) {
    this.setState({ feedback: e.currentTarget.value });
  }

  render() {
    return (
      <form className="assignments-feedback" onSubmit={this.props.onSubmit}>
        <label htmlFor="give-feedback">{i18n.t("labs.leave-feedback")}</label>
        <textarea
          rows="1"
          id="give-feedback"
          onChange={this._updateFeedback}
          placeholder={
            i18n.t("labs.want-your-feedback") +
            " " +
            i18n.t("labs.what-did-you-think", { lab: this.props.lab })
          }
          value={this.state.feedback}
        />
        <button className="submit large-button">{i18n.t("base.submit")}</button>
        <button
          className="noButton not-now"
          onClick={this.props.rateLater}
          type="button"
        >
          {i18n.t("labs.not-now")}
        </button>
      </form>
    );
  }
}
